<div class="api-card">
  <div class="api-card__header">
    <div class="api-card__header-stack">
      <span class="api-card__title">Transactions</span>
      <span class="api-card__desc">All wallet transactions across organizations.</span>
    </div>
  </div>


  <div class="admin-table-scroll">
    <table class="billing-table admin-stack admin-stack--txns-preview">
      <thead>
        <tr>
          <th>Organization</th>
          <th>Kind</th>
          <th class="col-num">Amount</th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading) {
          @for (i of [1,2,3,4]; track i) {
            <tr>
              <td><app-skeleton width="65%" height="14px"></app-skeleton></td>
              <td><app-skeleton width="60px" height="20px" radius="4px"></app-skeleton></td>
              <td><app-skeleton width="60px" height="14px"></app-skeleton></td>
            </tr>
          }
        } @else {
          @for (row of rows; track row.id) {
            <tr>
              <td>{{ row.organization?.name ?? '-' }}</td>
              <td><span [class]="'txn-kind-badge txn-kind-badge--' + row.kind">{{ row.kind }}</span></td>
              <td class="col-num" [class.billing-card__balance--negative]="!row.isCredit">
                {{ row.isCredit ? '+' : '' }}{{ (row.amountCents / 100).toFixed(2) }} {{ row.currency | uppercase }}
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <div class="api-card__footer">
    <a routerLink="/admin/transactions" class="link">
      View all transactions
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
</div>
